<template>
  <div>
    {{ amount | currency(order.currency_label) }}
    <span v-if="showFees && fees" class="text-muted text-sm whitespace-no-wrap">
      (+{{ fees | currency(order.currency_label) }})
    </span>
  </div>
</template>

<script>
export default {
  name: 'OrderAmount',

  props: {
    showFees: {
      type: Boolean,
      default: true,
    },
    order: {
      type: Object,
      require: true,
      default: () => {
        return {}
      },
    },
  },

  computed: {
    fees() {
      return this.order.fees_amount
    },
    amount() {
      return this.order.subtotal
    },
  },
}
</script>
